// src/pages/Home.jsx
import React, { useEffect } from "react";

import Hero from "../components/hero/Hero";
import AboutSection from "../components/about/AboutSection";
import SectionTitle from "../components/common/SectionTitle";
// import ServiceCard from '../components/services/ServiceCard';
import TestimonialSlider from "../components/testimonials/TestimonialSlider";
import AppointmentForm from "../components/appointment/AppointmentForm";
import services from "../data/services";
import DoctorImage from "../Assets/TeamandOthers/sridhar_reddyimg.png";
import DoctorbgImage from "../Assets/TeamandOthers/Sridharbg1.webp";
import contactImage from "../Assets/TeamandOthers/Reception.webp";
import HorizontalCarousel from "../components/common/HorizontalCarousel";
import image1 from "../Assets/TeamandOthers/Gallery12.webp";
import image2 from "../Assets/Services/Service2-2.jpg";
import image3 from "../Assets/Services/Laserdentistry.jpg";
import { Helmet } from "react-helmet";

import { Link } from "react-router-dom";

const Home = () => {
  useEffect(() => {
    const cards = document.querySelectorAll(".founder-parallax-card");
    if (!cards.length) return;

    const range = 40;
    const calcValue = (pos, size) => (pos / size) * range - range / 2;

    let rafId = null;

    const handleMouseMove = (e) => {
      if (rafId) cancelAnimationFrame(rafId);

      rafId = requestAnimationFrame(() => {
        const xValue = calcValue(e.clientX, window.innerWidth);
        const yValue = calcValue(e.clientY, window.innerHeight);

        cards.forEach((card) => {
          // Card tilt
          card.style.transform = `
          rotateX(${yValue}deg)
          rotateY(${xValue}deg)
        `;

          // Foreground image depth
          const img = card.querySelector(".founder-parallax-card__img");
          if (img) {
            img.style.transform = `
            translateX(${-xValue * 1.5}px)
            translateY(${yValue * 1.5}px)
            translateZ(80px)
          `;
          }

          // Background drift
          const bg = card.querySelector(".founder-parallax-card__bg");
          if (bg) {
            bg.style.backgroundPosition = `
            ${xValue * 0.45}px
            ${-yValue * 0.45}px
          `;
          }
        });
      });
    };

    const reset = () => {
      cards.forEach((card) => {
        card.style.transform = "rotateX(0deg) rotateY(0deg)";

        const img = card.querySelector(".founder-parallax-card__img");
        if (img) {
          img.style.transform = "translateZ(0)";
        }
      });
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseleave", reset);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseleave", reset);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);
  return (
    <main className="">
      <Helmet>
        <title>
          Sridhar Dental | Trusted Dentists in Vijayawada & Hyderabad
        </title>
        <meta
          name="description"
          content="Looking for the best dental hospital in Vijayawada? Dr. Sridhar Dental offers implants, root canal, Invisalign & smile designing with expert care."
        />
        <meta
          name="keywords"
          content="best dental hospital Hyderabad, dentist near me, dental clinic Hyderabad, Dr Sridhar dental"
        />
        <meta name="author" content="Dr Sridhar Dental" />
        <meta name="publisher" content="Dr Sridhar Dental" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://sridhardental.com/" />

        <meta
          property="og:title"
          content="Sridhar Dental | Trusted Dentists in Vijayawada & Hyderabad"
        />

        <meta property="og:site_name" content="Sridhardental" />

        <meta property="og:url" content="https://sridhardental.com" />

        <meta
          property="og:description"
          content="Looking for the best dental hospital in Vijayawada? Dr. Sridhar Dental offers implants, root canal, Invisalign & smile designing with expert care."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:image"
          content="https://sridhardental.com/static/media/sridhar_reddyimg.49f48c6c827d7445253f.png"
        />

        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Sridhar Dental | Trusted Dentists in Vijayawada & Hyderabad"
        />

        <meta
          name="twitter:description"
          content="Looking for the best dental hospital in Vijayawada? Dr. Sridhar Dental offers implants, root canal, Invisalign & smile designing with expert care."
        />

        <meta
          name="twitter:image"
          content="https://sridhardental.com/static/media/sridhar_reddyimg.49f48c6c827d7445253f.png"
        />
      </Helmet>
      <Hero />

      {/* Leadership Section - Acharya Dental style adaptation */}
      <section className="leaderSection bg-[#0d47a1] text-white py-16 md:py-16 overflow-hidden -mt-40">
        <div className="container mx-auto px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-10 md:gap-16">
            {/* LEFT — Text */}
            <div className="md:w-1/2 text-center md:text-left flex flex-col items-center md:items-start">
              {/* UPDATED: Leadership heading now uses consistent 3xl across all breakpoints */}
              <h2 className="text-3xl md:text-3xl lg:text-3xl font-bold mb-6 leading-tight">
                Leadership
              </h2>

              <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-6 max-w-xl opacity-90 leading-relaxed">
                Under the leadership of Dr Arumalla Sridhar Reddy, a leading
                Dental, Oral, and Maxillofacial surgeon by Profession Sridhar
                International Dental clinic began its operations in 1995.
              </p>

              <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-8 max-w-xl opacity-90 leading-relaxed">
                Since then, it’s been achieving excellence in dentistry through
                holistic approaches and personalized treatment processes. It was
                beyond commercials to him, hence the vision became a reality.
              </p>
              <div className="inline-block bg-white text-[#0d47a1] px-8 py-4 rounded-full text-1xl font-bold shadow-lg">
                30+ Years Experience
              </div>
            </div>

            {/* RIGHT — Parallax Doctor Card */}
            <div className="flex justify-center md:justify-start">
              <div className="text-center flex flex-col items-center">
                {/* Floating + Glow Wrapper */}
                <div className="relative animate-float-slow mb-6">
                  {/* Glow */}
                  <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-400/30 to-cyan-400/20 blur-3xl scale-110 -z-10"></div>

                  {/* === PARALLAX CARD === */}
                  <div className="founder-parallax-card relative w-48 h-48 md:w-96 md:h-96 rounded-full overflow-hidden border-8 border-white shadow-2xl cursor-pointer">
                    {/* Background layer */}
                    <div
                      className="founder-parallax-card__bg absolute inset-0"
                      style={{
                        backgroundImage: `url(${DoctorbgImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        // filter: 'brightness(0.6) blur(3px)',
                      }}
                    />

                    {/* Foreground Image */}
                    <img
                      src={DoctorImage}
                      alt="Dr. Arumalla Sridhar Reddy"
                      className="founder-parallax-card__img w-full h-full object-cover"
                    />
                  </div>
                </div>

                {/* Text Below Image */}
                <h3 className="text-xl md:text-1xl font-bold">
                  Dr. Arumalla Sridhar Reddy
                </h3>

                <p className="text-blue-200 mt-1">
                  BDS, MDS – Oral & Maxillofacial Surgeon
                </p>

                <p className="text-sm md:text-base mt-1 opacity-90">
                  Founder & Chairman
                </p>
              </div>
            </div>
          </div>

          {/* Bottom Caption */}
          <div className="text-center mt-12 opacity-90 text-lg md:text-xl">
            Transforming smiles with precision, care and 30+ years of excellence
          </div>
        </div>
      </section>

      <AboutSection />

      {/* Services Section – exact match to reference style */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <span className="inline-block bg-white text-blue-600 px-6 py-2 rounded-full font-medium text-xl shadow-sm mb-6">
              Our Services
            </span>
            {/* UPDATED: Services heading now uses consistent 3xl across all breakpoints */}
            <h2 className="text-3xl md:text-3xl lg:text-3xl font-bold text-gray-900 mb-6 leading-tight">
              Services
            </h2>
            <p className="text-gray-600 mx-auto text-base md:text-base lg:text-[16px] leading-relaxed">
              Our dental hospital offers complete oral healthcare services
              including preventive, cosmetic, and restorative treatments using
              the latest dental technology.
            </p>
          </div>
          <HorizontalCarousel interval={3000}>
            {services.map((service, index) => (
              <div key={index} className="px-3 h-full">
                <div className="relative flex flex-col bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden h-full">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-[200px] object-cover"
                  />
                  <div className="p-6">
                    <h3 className="text-xl font-bold mb-2">{service.title}</h3>
                    <p className="text-gray-600 mb-4">{service.description}</p>
                    <a
                      href={service.link}
                      className="text-blue-600 font-semibold hover:underline"
                    >
                      Learn More →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </HorizontalCarousel>
        </div>
      </section>

      <section className="relative min-h-[400px] md:min-h-[520px] flex items-center bg-[#0d47a1] overflow-hidden">
        {/* 1. The Skewed Image Wrapper (The Mask) */}
        {/* HIDDEN ON MOBILE: "hidden md:block" hides this entire div on screens < 768px */}
        <div
          className="hidden md:block absolute top-0 right-0 h-full w-full md:w-[55%] lg:w-[50%] overflow-hidden z-10 
               translate-x-[15%] md:translate-x-[12%] skew-x-12"
        >
          {/* The Actual Image - Unskewed */}
          <div
            className="absolute top-0 left-0 h-full w-full -skew-x-12 bg-cover bg-center"
            style={{
              backgroundImage: `url(${contactImage})`,
              backgroundPosition: "center",
              marginLeft: "-10%",
            }}
          />
        </div>

        {/* 2. The Content Layer (CRISP TEXT - NO TRANSFORMS) */}
        <div className="container mx-auto px-6 relative z-30">
          {/* 
        Responsive Wrapper:
        - Mobile: max-w-full (full width wrapping)
        - Tablet (1024px): max-w-[70%] (matches your skewSection logic)
        - Desktop: max-w-xl or 2xl
    */}
          <div className="w-full lg:max-w-2xl md:max-w-[50%] text-white">
            <p className="text-teal-200 uppercase tracking-widest font-bold text-sm md:text-base mb-4">
              The Best Services
            </p>

            {/* UPDATED: Service banner heading now uses consistent 3xl across all breakpoints */}
            <h2 className="text-3xl md:text-3xl lg:text-3xl text-white font-bold leading-tight mb-6">
              Dedicated to Give You <br className="hidden sm:block" /> The Best
              Services
            </h2>
            <p className="text-white/90 text-base md:text-base lg:text-[16px] leading-relaxed mb-8">
              We provide state-of-the-art dental care with precision, comfort,
              and compassion. Our team ensures each patient receives
              personalized treatments for a healthier, brighter smile.
            </p>

            {/* 
          Responsive Button Width:
          - Mobile: w-[55%] or w-fit
          - Desktop: w-fit 
      */}
            <Link
              to="/contact"
              className="inline-flex items-center justify-center bg-white text-[#0d47a1] 
                   font-bold text-base rounded-full px-10 py-4 transition-all 
                   duration-300 shadow-xl hover:bg-teal-50 hover:-translate-y-1 
                   w-full sm:w-fit"
            >
              Contact Us
            </Link>
          </div>
        </div>

        {/* Gradient Overlay for Desktop only */}
        <div className="hidden md:block absolute inset-0 pointer-events-none z-20 bg-gradient-to-r from-[#0d47a1] via-[#0d47a1]/20 to-transparent" />
      </section>

      {/* Technology Section */}
      <section className="py-24 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-20">
            <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-blue-50 text-blue-600 text-xl font-medium mb-6">
              <span className="w-2 h-2 bg-blue-600 rounded-full"></span>
              Technology Driven Care
            </span>

            {/* SectionTitle component - update the component itself for consistent styling */}
            <SectionTitle title="Advanced Dental Technology" />
            <p className="mt-6 text-gray-500 max-w-3xl mx-auto text-base md:text-base lg:text-[16px] leading-relaxed">
              Precision dentistry powered by world-class digital systems,
              delivering faster, safer, and more comfortable treatments.
            </p>
          </div>

          {/* Cards */}
          <div className="grid md:grid-cols-3 gap-12 max-w-6xl mx-auto">
            {/* Card */}
            <div className="group relative p-10 rounded-3xl border border-white/60 bg-white/60 backdrop-blur-xl shadow-[0_30px_60px_-20px_rgba(0,0,0,0.1)] hover:shadow-[0_40px_80px_-20px_rgba(37,99,235,0.25)] transition-all duration-500 hover:-translate-y-3">
              {/* Glow */}
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition"></div>

              {/* Icon */}
              <div className="relative w-full h-24 mb-6 overflow-hidden rounded-xl">
                <img
                  src={image1}
                  alt="CEREC CAD CAM"
                  className="w-full h-full object-cover"
                />
              </div>

              <h3 className="relative z-10 text-2xl font-semibold text-gray-900 mb-4">
                CEREC CAD/CAM
              </h3>

              <p className="relative z-10 text-gray-600 text-base md:text-base lg:text-[16px] leading-relaxed">
                India’s first same-day crown technology delivering digitally
                designed, precision-milled restorations in a single visit.
              </p>
            </div>

            {/* Card */}
            <div className="group relative p-10 rounded-3xl border border-white/60 bg-white/60 backdrop-blur-xl shadow-[0_30px_60px_-20px_rgba(0,0,0,0.1)] hover:shadow-[0_40px_80px_-20px_rgba(37,99,235,0.25)] transition-all duration-500 hover:-translate-y-3">
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition"></div>

              <div className="relative w-full h-24 mb-6 overflow-hidden rounded-xl">
                <img
                  src={image2}
                  alt="Dental Implants"
                  className="w-full h-full object-cover"
                />
              </div>

              <h3 className="relative z-10 text-2xl font-semibold text-gray-900 mb-4">
                Dental Implants
              </h3>

              <p className="relative z-10 text-gray-600 text-base md:text-base lg:text-[16px] leading-relaxed">
                Advanced implant systems combined with digital planning for
                higher accuracy, faster healing, and long-term success.
              </p>
            </div>

            {/* Card */}
            <div className="group relative p-10 rounded-3xl border border-white/60 bg-white/60 backdrop-blur-xl shadow-[0_30px_60px_-20px_rgba(0,0,0,0.1)] hover:shadow-[0_40px_80px_-20px_rgba(37,99,235,0.25)] transition-all duration-500 hover:-translate-y-3">
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition"></div>

              <div className="relative w-full h-24 mb-6 overflow-hidden rounded-xl">
                <img
                  src={image3}
                  alt="Laser Dentistry"
                  className="w-full h-full object-cover"
                />
              </div>

              <h3 className="relative z-10 text-2xl font-semibold text-gray-900 mb-4">
                Laser Dentistry
              </h3>

              <p className="relative z-10 text-gray-600 text-base md:text-base lg:text-[16px] leading-relaxed">
                Minimally invasive laser treatments offering pain-free
                procedures, reduced bleeding, and quicker recovery times.
              </p>
            </div>
          </div>
        </div>
      </section>

      <TestimonialSlider />
      <AppointmentForm />
    </main>
  );
};

export default Home;
